import { render } from "./CourseOverview.vue?vue&type=template&id=70284518"
import script from "./CourseOverview.vue?vue&type=script&lang=js"
export * from "./CourseOverview.vue?vue&type=script&lang=js"

import "./CourseOverview.vue?vue&type=style&index=0&id=70284518&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__